import {
  classifyPublicationRoute as classifySharedPublicationRoute,
  isSelectivePublicationRouteAllowed,
  PUBLICATION_ROUTE_CLASSES,
  PUBLICATION_ROUTE_OUTCOMES,
  resolvePublicationRouteOutcome,
} from '../../shared/publicationRoutePolicy.js';
import {
  STAFF_LOGIN_PATH,
  STAFF_RESET_PATH,
} from '../../shared/publicationAccess.js';

export {
  isSelectivePublicationRouteAllowed,
  PUBLICATION_ROUTE_CLASSES,
  PUBLICATION_ROUTE_OUTCOMES,
  resolvePublicationRouteOutcome,
};

export const classifyPublicationRoute = (pathname) =>
  classifySharedPublicationRoute(pathname, {
    staffLoginPath: STAFF_LOGIN_PATH,
    staffResetPath: STAFF_RESET_PATH,
  });
